import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'react-share'
import Image from 'next/image'
import { useEffect, useState } from 'react'

export default function ShareLink({ postsDetail }) {
  const [currentUrl, setCurrentUrl] = useState('')

  useEffect(() => {
    setCurrentUrl(window.location.href)
  }, [])

  const handleCopyLink = () => {
    navigator.clipboard.writeText(currentUrl)
    alert('Copied to clipboard')
  }

  return (
    <div className="flex items-center gap-3">
      <div
        className="flex items-center justify-center border border-solid border-[#D0D5DD] rounded-lg p-[10px] grayscale hover:grayscale-0 cursor-pointer"
        onClick={handleCopyLink}
      >
        <Image
          src="/images/blog/link.svg"
          className="object-contain"
          alt="Copy"
          height={20}
          width={20}
        />
      </div>
      <TwitterShareButton
        title={postsDetail?.title.rendered}
        via={postsDetail?.excerpt.rendered}
        url={currentUrl}
        hashtags={['#locker']}
      >
        <div className="flex items-center justify-center border border-solid border-[#D0D5DD] rounded-lg p-[10px] grayscale hover:grayscale-0">
          <Image
            src="/images/blog/twitter.svg"
            className="object-contain"
            alt="X"
            height={20}
            width={20}
          />
        </div>
      </TwitterShareButton>
      <FacebookShareButton
        url={currentUrl || ''}
        hashtag={'#locker'}
        description={postsDetail?.excerpt?.rendered}
      >
        <div className="flex items-center justify-center border border-solid border-[#D0D5DD] rounded-lg p-[10px] grayscale hover:grayscale-0">
          <Image
            src="/images/blog/facebook.svg"
            className="object-contain"
            alt="Facebook"
            height={20}
            width={20}
          />
        </div>
      </FacebookShareButton>
      <LinkedinShareButton
        title={postsDetail?.title?.rendered}
        url={currentUrl || ''}
        summary={postsDetail?.excerpt?.rendered}
      >
        <div className="flex items-center justify-center border border-solid border-[#D0D5DD] rounded-lg p-[10px] grayscale hover:grayscale-0">
          <Image
            src="/images/blog/linkein.svg"
            className="object-contain"
            alt="LinkedIn"
            height={20}
            width={20}
          />
        </div>
      </LinkedinShareButton>
    </div>
  )
}
